module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/8-e6ff7ae3717c64fecb3131a791ed63e7.png";